// 「這個分頁剛完成 Portal 註冊」這件事的載體。
//
// sessionStorage 是 per-tab、撐得過整頁跳轉、關掉分頁自動清乾淨，正好對應這個
// 一次性事件；為什麼不用 query param / Rails flash 見 docs/portal_login.md。
const STORAGE_KEY = 'portalRegisteredEmail'

// 私密瀏覽或瀏覽器停用儲存時，存取本身就會丟例外 —— 一律退化成「不顯示提示」，
// 絕不能讓一句提示炸掉註冊或登入頁。
export function saveRegisteredEmail(email) {
  try {
    sessionStorage.setItem(STORAGE_KEY, email || '')
  } catch {
    // ignore
  }
}

// 讀完即刪：訊息只屬於「剛完成註冊」那一次，重整或之後再回到登入頁都不該再出現。
export function takeRegisteredEmail() {
  try {
    const email = sessionStorage.getItem(STORAGE_KEY)
    if (email !== null) sessionStorage.removeItem(STORAGE_KEY)
    return email
  } catch {
    return null
  }
}
